const localization = {}

export default localization
